import PerfectScrollbar from 'perfect-scrollbar';

$(document).ready(function() {

    var ps;

    if($('.js-scroll-modal').height() > 0) {
    	ps = new PerfectScrollbar('.js-scroll-modal', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
		});
    }

    $('.b-modal-slider-result__container').bind('touchstart', function() {
        if ($(window).width() < 700) {
            ps.destroy();
        }
    });

    $('.b-modal-slider-result__container').bind('touchend', function() {
        if ($(window).width() < 700) {
            ps = new PerfectScrollbar('.js-scroll-modal', {
				wheelSpeed: 0.8,
				wheelPropagation: true,
				minScrollbarLength:180,
				maxScrollbarLength:180,
			});
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-exponat/exponat-scroll.js